module.exports = __webpack_public_path__ + "img/22.383ae5f.png";